import React from 'react';

const ComparisonIcon = ({color= '#1536A1', width= '18', height='16'}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1.65" y1="12.75" x2="1.65" y2="21.25" stroke={color} strokeWidth="3.3"/>
      <line x1="8.3165" y1="7.08325" x2="8.3165" y2="21.2499" stroke={color} strokeWidth="3.3"/>
      <line x1="14.9835" y1="-6.13052e-08" x2="14.9835" y2="21.25" stroke={color} strokeWidth="3.3"/>
      <line x1="21.65" y1="12.75" x2="21.65" y2="21.25" stroke={color} strokeWidth="3.3"/>
    </svg>
  );
}

export default ComparisonIcon;
